<!-- eslint-disable max-lines -->
<template>
    <div>
        <div v-if="isDetail">
            <el-button @click="back">返 回</el-button>
            <el-table :data="detailData" border style="width: 100%">
                <el-table-column v-for="item in detailTableColumn" :key="item.prop"
                    :prop="item.prop" :label="item.label" width="180">
                </el-table-column>
            </el-table>
        </div>
        <m-pane v-else ref="tablePage" class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @row-db-click="rowDBclick"
            @configBind-btn="handleBind"
            @configCancel-btn="handleCancel"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="ETTA_SK_QUERY">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05020002'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="appointment" v-has="'05010201'">送货预约</el-button>
                <el-button type="primary" @click="amendTheTreaty" v-has="'05010202'">配送改约</el-button>
                <el-button type="primary" @click="warehouseAbnormal" v-has="'05010203'">仓内异常</el-button>
                <el-button type="primary" @click="abnormal" v-has="'05010204'">配送异常</el-button>
            </div>
        </m-pane>
        <el-dialog
            title="送货预约"
            :visible.sync="appointmentVisible"
            width="40%"
            @close="handleAppointmentClose">
            <el-form ref="form" label-position="right" label-width="100px"
                inline
                :model="ruleForm"
                :rules="rules">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="客户预约单号">
                            <el-input v-model="ruleForm.ettaReservationNo" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="改约时间：" prop="appointmentValue">
                            <el-date-picker v-model="ruleForm.appointmentValue"
                                type="datetime" default-time="23:59:59" placeholder="选择日期时间" style="width: 180px">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="改约一级原因" prop="ettaMarkOne">
                            <otpSelect style="width: 180px" :optionNum="'OTP_CHANGE_DELIVERY_1'" :mValue="ruleForm.ettaMarkOne"
                                @getSelectValue="getSelectValue" :prop="'ettaMarkOne'">
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="改约二级原因" prop="ettaMarkTwo">
                            <el-select v-model="ruleForm.ettaMarkTwo" placeholder="请选择">
                                <el-option v-for="item in ettaMarkTwoOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="改约原因描述">
                            <el-input v-model="ruleForm.appointmentRemark" placeholder="请输入内容" style="width: 180px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleAppointmentClose()}">取 消</el-button>
                <el-button type="primary" @click="handleAppointmentChange">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="配送改约" width="40%"
            :visible.sync="amendVisible"
            @close="handleAmendClose">
                客户预约单号：
                <el-input v-model="amendNO" placeholder="请输入内容" style="width: 150px;"></el-input>
                改约送达时间：
                <el-date-picker
                    v-model="amendValue"
                    type="datetime"
                    placeholder="选择日期时间"
                    style="margin-right: 20px">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleAmendClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleAmendChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog title="仓内异常" width="30%"
            :visible.sync="warehouseVisible"
            @close="handleWarehouseClose">
                仓内异常原因:
                <el-select v-model="warehouseReason" placeholder="请选择">
                    <el-option
                        v-for="item in warehouseArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleWarehouseClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleWarehouseChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog title="配送异常" width="30%"
            :visible.sync="deliveryVisible"
            @close="handleDeliveryClose">
                配送异常原因:
                <el-select v-model="deliveryReason" placeholder="请选择">
                    <el-option
                        v-for="item in deliveryArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleDeliveryClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleDeliveryChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog title="设备号" width="30%"
            :visible.sync="deviceNoVisible"
            @close="handleDeviceNoVisible">
                设备号:
                <el-input v-model="deviceNo" placeholder="请输入设备号" style="width: 150px;"></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleDeviceNoVisible()}">取 消</el-button>
                    <el-button :loading="deviceLoading" type="primary" @click="handleBindConfirm">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import otpSelect from '@/components/lots/otpSelect';
import config from './config.js';
import { maxDay } from '@/modules/transport/tms/common/common';
import dayjs from 'dayjs';
import reportExport from '@/components/lots/reportExportPlugin';
import { detailColumn } from './tableColumn';
import {
    getTransportList,
    saveTaskConversion,
    saveWarehouseAbnormal,
    saveDistributeAbnormal,
    saveTaskReservation,
    getDictionaryDetailByCode,
    getEtTaskMaterielItem,
    updateDeviceGps
} from '../../../api/appointment';
import { ConstantsTES } from '../../../constans/constans';
import { mapGetters } from 'vuex';
import utils from '@/utils/common';
const { getSessionKey } = utils;
const ettaCarrierIssued = 10;
const isCarrier = 'N';
const noDepart = 40; // 未发车
const OPERATE_TYPE = ['create', 'cancel'];
export default {
    components: { mPane, otpSelect, reportExport },
    mounted() {
        this.initSessionData();
    },
    computed: {
        ...mapGetters(['supplier', 'currentTenant'])
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            selectArray: [], // 选中的集合
            appointmentVisible: false, // 送货预约弹窗
            deliveryVisible: false, // 配送异常弹窗
            deliveryReason: '', // 配送异常弹窗选中的值
            deliveryArray: [], // 配送异常弹窗可选值
            amendVisible: false, // 配送改约弹窗
            amendNO: '', // 配送改约客户预约单号
            amendValue: '', // 配送改约送达时间
            detailTableColumn: detailColumn, // 详情页column
            warehouseVisible: false, // 仓内异常弹窗
            warehouseReason: '', // 仓内异常弹窗选中的值
            warehouseArray: [], // 仓内异常弹窗可选值
            isDetail: false, // 详情页
            isFirstSearch: true,
            detailData: [], // 详情页table的data
            ettaMarkTwoOptions: [], // 二级改约原因可选项
            exportParams: {},
            ruleForm: {
                ettaReservationNo: '', // 客户预约单号
                appointmentValue: '', // 改约时间
                ettaMarkOne: '', // 一级改约原因
                ettaMarkTwo: '', // 二级改约原因
                appointmentRemark: '' // 改约原因描述
            },
            rules: {
                appointmentValue: [ { required: true, message: '请选择改约时间', trigger: 'change' } ],
                ettaMarkOne: [ { required: true, message: '请选择一级改约原因', trigger: 'change' } ],
                ettaMarkTwo: [ { required: true, message: '请选择二级改约原因', trigger: 'change' } ]
            },
            deviceNo: null,
            deviceNoVisible: false, // 设备号弹窗
            currentRow: null, // 当前操作行数据
            deviceLoading: false
        };
    },
    methods: {
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getTransportList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.exportParams = {
                ...this.searchData,
                ettaCarrierEbcuCode: this.supplier.supplierCode,
                ettaCarrierIssued
            };
            this.loading = true;
            const { SYS_TRANSPORT_TASK_STATUS, SYS_TMS_ORDER_SOURCE, OMS_TRANS_TYPE, SYS_LMDM_PRIOR_LEVEL, SYS_TMS_TRANSPORT_TYPE, SYS_SUPPLIER_YES_NO
            } = sessionStorage;
            getTransportList({ pageNo, pageSize: this.pageSize, ettaCarrierEbcuCode: this.supplier.supplierCode, ettaCarrierIssued, isCarrier, ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        item.ettaLevelType = getSessionKey(item.ettaLevel, SYS_LMDM_PRIOR_LEVEL); // 紧急程度
                        item.ettaReservationType = getSessionKey(item.ettaReservation, SYS_SUPPLIER_YES_NO); // 是否预约
                        item.ettaTranTypeNew = getSessionKey(item.ettaTranType, SYS_TMS_TRANSPORT_TYPE); // 运输方式
                        item.ettaStatusType = getSessionKey(item.ettaStatus, SYS_TRANSPORT_TASK_STATUS); // 运输单状态
                        item.etta2b2cType = getSessionKey(item.etta2b2c, SYS_TMS_ORDER_SOURCE); // 订单来源
                        item.ettaDeliveryTypeCodeType = getSessionKey(item.ettaDeliveryTypeCode, OMS_TRANS_TYPE); // C端配送方式
                        item.etIsSupllyAppointmentType = +item.etIsSupllyAppointment ? '是' : '否'; // 是否供方预约
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        // 获取数据字典
        _getDictionaryDetailByCode(key) {
            return getDictionaryDetailByCode({ dictCodes: key }).then(res => {
                if (res && +res.code === 0) return res.data;
            });
        },
        // 送货预约
        _saveTaskReservation() {
            const { ettaReservationNo, appointmentValue, ettaMarkOne, ettaMarkTwo, appointmentRemark
            } = this.ruleForm;
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    saveTaskReservation({
                        ettaReservationNo,
                        ettaReservationTime: dayjs(appointmentValue).format('YYYY-MM-DD HH:mm:ss'),
                        ettaMarkOne,
                        ettaMarkTwo,
                        appointmentRemark,
                        ettaIds: this.selectArray.map(item => item.ettaId),
                        businessOperator: this.supplier.supplierNameCn
                    }).then(res => {
                        if (res && +res.code === 0) {
                            if (!res.data.success) {
                                this.$message.error(res.data.messagesAsString);
                            } else {
                                this.$message.success('成功!');
                                this.handleAppointmentClose(true);
                            }
                        }
                    });
                }
            });
        },
        // 配送改约
        _saveTaskConversion() {
            saveTaskConversion({
                ettaReservationNo: this.amendNO,
                ettaReservationTime: dayjs(this.amendValue).format('YYYY-MM-DD HH:mm:ss'),
                ettaIds: this.selectArray.map(item => item.ettaId),
                businessOperator: this.supplier.supplierNameCn
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleAmendClose(true);
                    }
                }
            });
        },
        // 仓内异常
        _saveWarehouseAbnormal() {
            saveWarehouseAbnormal({
                ettaIds: this.selectArray.map(item => item.ettaId),
                businessOperator: this.supplier.supplierNameCn,
                warehouseReason: this.warehouseReason
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleWarehouseClose(true);
                    }
                }
            });
        },
        // 配送异常
        _saveDistributeAbnormal() {
            saveDistributeAbnormal({
                distributeReason: this.deliveryReason,
                businessOperator: this.supplier.supplierNameCn,
                ettaIds: this.selectArray.map(item => item.ettaId)
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleDeliveryClose(true);
                    }
                }
            });
        },
        _getEtTaskMaterielItem(etupEttaNo) {
            getEtTaskMaterielItem({ etupEttaNo }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.detailData = res.data.data;
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
            });
        },
        initSessionData() {
            this.setSessionStorage('SYS_LMDM_PRIOR_LEVEL');
            this.setSessionStorage('SYS_TMS_TRANSPORT_TYPE');
            this.setSessionStorage('SYS_SUPPLIER_YES_NO');
        },
        setSessionStorage(key) {
            !sessionStorage[key] && this._getDictionaryDetailByCode(key).then(res => {
                sessionStorage[key] = JSON.stringify(res[key]);
            });
        },
        pageChange(val) {
            this.currentPage = val;
            this._getTransportList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getTransportList();
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            this.searchData = val;
            this._getTransportList();
        },
        selectChange(data) {
            this.selectArray = data;
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm') : '',
                ettaReqDeliveryDateF: data.shipmentsTime && data.shipmentsTime.length ? dayjs(data.shipmentsTime[0]).format('YYYY-MM-DD HH:mm') : '',
                ettaReqDeliveryDateT: data.shipmentsTime && data.shipmentsTime.length ? dayjs(data.shipmentsTime[1]).format('YYYY-MM-DD HH:mm') : '',
                ...data
            };
            delete tempData.createTime;
            delete tempData.carTime;
            return tempData;
        },
        // 送货预约
        appointment() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            const { TASK_STATUS_ROWOFCARS, TASK_STATUS_NEW, TASK_STATUS_SHUNTING, TASK_STATUS_THECAR } = ConstantsTES;
            for (const item of this.selectArray) {
                if (item.ettaStatus !== TASK_STATUS_NEW && item.ettaStatus !== TASK_STATUS_ROWOFCARS &&
                    item.ettaStatus !== TASK_STATUS_SHUNTING && item.ettaStatus !== TASK_STATUS_THECAR) {
                    this.$message.error('存在已发货订单，不能预约。');
                    return false;
                }
            }
            this.appointmentVisible = true;
        },
        handleAppointmentClose(req) {
            this.appointmentVisible = false;
            this.ruleForm = {
                ettaReservationNo: '', // 客户预约单号
                appointmentValue: '', // 改约时间
                ettaMarkOne: '', // 一级改约原因
                ettaMarkTwo: '', // 二级改约原因
                appointmentRemark: '' // 改约原因描述
            };
            this.ettaMarkTwoOptions = [];
            this.$refs.form.resetFields();
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleAppointmentChange() {
            this._saveTaskReservation();
        },
        // 配送改约
        amendTheTreaty() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做配送预约！');
                    return false;
                }
                if (+item.ettaStatus <= noDepart) {
                    this.$message.error('运输单' + item.ettaNo + '尚未发车，先做配送预约，发车后的单据才做改约！');
                    return false;
                }
            }
            this.amendVisible = true;
        },
        handleAmendClose(req) {
            this.amendVisible = false;
            this.amendNO = '';
            this.amendValue = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleAmendChange() {
            if (!this.amendValue) {
                this.$message.error('请选中改约时间!');
                return false;
            }
            this._saveTaskConversion();
        },
        // 仓内异常
        warehouseAbnormal() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            if (this.selectArray.length > 1) {
                this.$message.error('只能选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做仓内异常反馈');
                    return false;
                }
                if (+item.ettaStatus === +ConstantsTES.TASK_STATUS_HANG || +item.ettaStatus === +ConstantsTES.TASK_STATUS_REVOKE) {
                    this.$message.error('运输单' + item.ettaNo + '为冲销或者挂起状态，不能执行仓内异常操作!');
                    return false;
                }
                if (+item.ettaStatus >= +ConstantsTES.TASK_STATUS_LOADING) {
                    this.$message.error('运输单' + item.ettaNo + '已出库，不能执行仓内异常操作!');
                    return false;
                }
            }
            this._getDictionaryDetailByCode('SYS_TMS_ELS_WAREHOUSE_REASON').then(res => {
                const arr = res.SYS_TMS_ELS_WAREHOUSE_REASON;
                for (const key in arr) {
                    if (arr[key] && key) {
                        this.warehouseArray.push({
                            label: arr[key],
                            value: key
                        });
                    }
                }
            });
            this.warehouseVisible = true;
        },
        handleWarehouseClose(req) {
            this.warehouseVisible = false;
            this.warehouseReason = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleWarehouseChange() {
            if (!this.warehouseReason) {
                this.$message.error('请选中原因');
                return false;
            }
            this._saveWarehouseAbnormal();
        },
        // 配送异常
        abnormal() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做配送异常反馈！');
                    return false;
                }
                if (+item.ettaStatus === +ConstantsTES.TASK_STATUS_HANG || +item.ettaStatus === +ConstantsTES.TASK_STATUS_REVOKE) {
                    this.$message.error('运输单' + item.ettaNo + '为冲销或者挂起状态，不能执行配送异常操作!');
                    return false;
                }
                if (+item.ettaStatus <= +ConstantsTES.TASK_STATUS_LOADING) {
                    this.$message.error('运输单' + item.ettaNo + '未发车，不能执行配送异常操作!');
                    return false;
                }
            }
            this._getDictionaryDetailByCode('SYS_TMS_DISPATCHING_ABNORMAL').then(res => {
                const arr = res.SYS_TMS_DISPATCHING_ABNORMAL;
                for (const key in arr) {
                    if (arr[key] && key) {
                        this.deliveryArray.push({
                            label: arr[key],
                            value: key
                        });
                    }
                }
            });
            this.deliveryVisible = true;
        },
        handleDeliveryClose(req) {
            this.deliveryVisible = false;
            this.deliveryReason = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleDeliveryChange() {
            if (!this.deliveryReason) {
                this.$message.error('请选中原因');
                return false;
            }
            this._saveDistributeAbnormal();
        },
        back() {
            this.isDetail = false;
            this._getTransportList();
        },
        rowDBclick(row) {
            this._getEtTaskMaterielItem(row.ettaNo);
            this.isDetail = true;
        },
        getSelectValue(data) {
            this.ruleForm.ettaMarkTwo = '';
            this.ettaMarkTwoOptions = [];
            if (data.ettaMarkOne) {
                this._getDictionaryDetailByCode('OTP_CHANGE_DELIVERY_2').then(res => {
                    const arr = res.OTP_CHANGE_DELIVERY_2;
                    for (const key in arr) {
                        if (arr[key] && key && +key.split('_')[0] === +data.ettaMarkOne) {
                            this.ettaMarkTwoOptions.push({
                                label: arr[key],
                                value: key
                            });
                        }
                    }
                });
            }
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        },
        handleBind(row) {
            if (this.handleDeviceValidate(row)) {
                this.currentRow = row;
                this.handleDeviceNoVisible(true);
            }
        },
        handleCancel(row) {
            if (this.handleDeviceValidate(row)) {
                if (!row.deviceName) {
                    this.$message.warning('无设备号，不能取消绑定');
                    return false;
                }
                this.currentRow = row;
                this._updateDeviceGps(OPERATE_TYPE[1]);
            }
        },
        handleDeviceNoVisible(flag) {
            this.deviceNoVisible = !!flag;
        },
        handleBindConfirm() {
            if (!this.deviceNo) {
                this.$message.error('请输入设备号');
                return false;
            } else {
                this._updateDeviceGps(
                    OPERATE_TYPE[0],
                    () => {
                        this.deviceNo = null;
                        this.handleDeviceNoVisible(false);
                    }
                );
            }
        },
        _updateDeviceGps(operateType, callback) {
            const { ettaContractNo, ettaStatus, deviceName } = this.currentRow;
            const params = {
                operateNo: ettaContractNo,
                type: 'BINDTYPE_CONTRACT',
                deviceType: 'G7',
                ettaStatus,
                operateType
            };
            if (operateType === OPERATE_TYPE[0]) {
                params.ettaDeviceNo = this.deviceNo;
            } else {
                params.ettaDeviceNo = deviceName;
            }
            this.deviceLoading = true;
            updateDeviceGps(params).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this._getTransportList(this.currentPage);
                        callback && callback();
                    }
                }
                this.deviceLoading = false;
            });
        },
        handleDeviceValidate(row) {
            let passFlag = false;
            const { TASK_STATUS_ROWOFCARS, TASK_STATUS_SHUNTING, TASK_STATUS_THECAR, TASK_STATUS_LOADING, TASK_STATUS_INTRANSIT } = ConstantsTES;
            const passStatus = [TASK_STATUS_ROWOFCARS, TASK_STATUS_SHUNTING, TASK_STATUS_THECAR, TASK_STATUS_LOADING, TASK_STATUS_INTRANSIT];
            if (row.ettaStatus && passStatus.indexOf(row.ettaStatus) < 0) {
                this.$message.warning({
                    message: '只有运输单状态是 已排车 \\ 已调车 \\ 已到车 \\ 已装货 \\ 在途 时可以绑定和取消',
                    duration: 5000
                });
            } else if (!row.ettaContractNo) {
                this.$message.warning('合同号为空，不能进行绑定或取消');
            } else {
                passFlag = true;
            }
            return passFlag;
        }
    }
};
</script>
